import React from "react";
import Tooltip from "./tooltip";

const Textarea = ({ label, tooltip = null, name, value, placeholder, onChange, max = null }) => {
  return (
    <li>
      {label &&
        (tooltip ? (
          <Tooltip label={label} tooltip={tooltip} />
        ) : (
          <span className="tit">{label}</span>
        ))}
      <div className="cont">
        <textarea
          name={name}
          maxLength={max}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </li>
  );
};

export default Textarea;
